import { render, staticRenderFns } from "./memberRegistration.vue?vue&type=template&id=7c8f6994"
import script from "./memberRegistration.vue?vue&type=script&lang=js"
export * from "./memberRegistration.vue?vue&type=script&lang=js"
import style0 from "./memberRegistration.vue?vue&type=style&index=0&id=7c8f6994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports